import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PaySelected = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const paymentWidgetRef = useRef(null);
  const paymentMethodsWidgetRef = useRef(null);

  const [isPaymentReady, setIsPaymentReady] = useState(false);

  useEffect(() => {
    if (!state) {
      alert("주문 정보가 없습니다.");
      navigate('/order/selected');
      return;
    }

    setIsPaymentReady(false);

    const script = document.createElement('script');
    script.src = "https://js.tosspayments.com/v1/payment-widget";
    script.async = true;

    script.onload = () => {
      const clientKey = process.env.REACT_APP_TOSS_CLIENT_KEY;

      if (!clientKey) {
        alert('토스 클라이언트 키가 없습니다.');
        return;
      }

      const paymentWidget = window.PaymentWidget(clientKey, "ANONYMOUS");

      const paymentMethodsWidget = paymentWidget.renderPaymentMethods(
        '#payment-method',
        {
          value: Number(state.amount || 0),
        }
      );

      paymentMethodsWidget.on('ready', () => {
        setIsPaymentReady(true);
      });

      paymentWidgetRef.current = paymentWidget;
      paymentMethodsWidgetRef.current = paymentMethodsWidget;
    };

    script.onerror = () => {
      alert('토스 결제 위젯을 불러오지 못했습니다.');
    };

    document.head.appendChild(script);

    return () => {
      setIsPaymentReady(false);

      paymentWidgetRef.current = null;
      paymentMethodsWidgetRef.current = null;

      const paymentMethodEl = document.getElementById('payment-method');
      if (paymentMethodEl) {
        paymentMethodEl.innerHTML = '';
      }

      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, [state, navigate]);

  const handleFinalPay = async () => {
    const paymentWidget = paymentWidgetRef.current;

    if (!isPaymentReady || !paymentWidget) {
      alert("결제수단을 불러오는 중입니다. 잠시 후 다시 시도해주세요.");
      return;
    }

    try {
      const generateRandomString = () =>
        window.btoa(Math.random().toString()).slice(0, 20);

      const selectedCartIds = Array.isArray(state.cartIds)
        ? state.cartIds.join(',')
        : '';

      let successUrl = `${window.location.origin}/success/selected?order_id=${encodeURIComponent(state.orderId)}&selected_cart_ids=${encodeURIComponent(selectedCartIds)}`;
      let failUrl = `${window.location.origin}/fail/selected?order_id=${encodeURIComponent(state.orderId)}&selected_cart_ids=${encodeURIComponent(selectedCartIds)}`;

      if (state.reserve_yn === 'Y' && state.pickup_datetime) {
        successUrl += `&reserve_yn=${encodeURIComponent(state.reserve_yn || 'Y')}`
          + `&pickup_date=${encodeURIComponent(state.pickup_date || '')}`
          + `&pickup_time=${encodeURIComponent(state.pickup_time || '')}`
          + `&pickup_datetime=${encodeURIComponent(state.pickup_datetime || '')}`;

        failUrl += `&reserve_yn=${encodeURIComponent(state.reserve_yn || 'Y')}`
          + `&pickup_date=${encodeURIComponent(state.pickup_date || '')}`
          + `&pickup_time=${encodeURIComponent(state.pickup_time || '')}`
          + `&pickup_datetime=${encodeURIComponent(state.pickup_datetime || '')}`;
      }

      await paymentWidget.requestPayment({
        orderId: generateRandomString(),
        orderName: state.orderName,
        customerName: state.buyerName,
        customerEmail: state.buyerEmail,
        successUrl,
        failUrl,
      });
    } catch (error) {
      if (error.code === 'USER_CANCEL') {
        console.log("사용자가 장바구니 결제를 취소했습니다.");
      } else {
        console.error("장바구니 결제 요청 중 오류 발생:", error);
        alert(error.message || "결제 요청 중 오류가 발생했습니다.");
      }
    }
  };

  return (
    <div className="container px-0" style={{ maxWidth: '600px', margin: '0 auto' }}>
      <div id="payment-method"></div>

      <div className="d-flex justify-content-center mt-0">
        <button
          onClick={handleFinalPay}
          disabled={!isPaymentReady}
          style={{
            width: '88%',
            height: '50px',
            padding: '0 16px',
          
            backgroundColor: isPaymentReady ? '#0073e9' : '#b8c7d9',
            color: '#fff',
            border: 'none',
            borderRadius: '30px',
          
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          
            fontSize: '15px',
            marginTop: '0px',
            cursor: isPaymentReady ? 'pointer' : 'not-allowed',
            opacity: isPaymentReady ? 1 : 0.8,
          }}
        >
          {isPaymentReady
            ? `${Number(state.amount || 0).toLocaleString()}원 결제하기`
            : '결제수단 불러오는 중...'}
        </button>
      </div>
    </div>
  );
};

export default PaySelected;